<script>
import resources from './resources'

export default {
  name: 'professional-locks-index',
  mixins: [resources]
}
</script>

<template lang="pug">
page(title="Bloqueios na Agenda Profissional", icon="")
  .col-xs-12.content
    .container-fluid
      .row
        medibook-alert-custom(
          :show='show',
          @close='show = false',
          message='Ainda não existe nenhuma Agenda cadastrada.',
          v-if="!statusAgenda")

        ul.nav.nav-tabs
          li.active
            a(href='#') Listagem
          li(v-if="!statusAgenda")
            a.mb-cursor-point(@click.prevent="show = true")
              | Cadastro
          li(v-if="statusAgenda")
            router-link(:to="{ name: 'professional.agenda.locks.create'}")
              a(href="") Cadastro

        .col-xs-12.white-bg.wrapper(v-if="loading")
          .row.border-bottom-light
            spinner(:show="true")

        .col-xs-12.white-bg.wrapper(v-if="!loading")
          .row.border-bottom-light
            .col-sm-offset-9.col-sm-3
              form.col-sm-12
                .form-group.busca(style='margin-top:30px;')
                  .row
                    .col-xs-9
                      input#buscar.form-control(v-model="search.name", type='text', placeholder='Buscar Bloqueios')
                    .col-xs-3
                      button.search(@click.prevent="doLoadAll()")
                        span.icon 
            a.mb-cursor-point(v-if="!statusAgenda", @click.prevent="show = true")
              .add-list.mb-cursor-point
                .icon-wrapper
                  span.icon 
                  .plus
                    span.icon 
                .text
                  | Novo<br>Bloqueio

            card-add(label='Novo<br>Bloqueio', route='professional.agenda.locks.create', icon='', v-if="statusAgenda")

            .list-item.white-bg.list-item(v-for=('lock in locks'))
              .row.border-bottom
                h4.col-xs-8(v-tooltip="lock.name") {{ lock.name_small }}
                .col-xs-4
                  .exclude-list(@click.prevent="doDelete(lock)")
                   span.icon 
                  router-link(:to="{name: getRouterEdit, params: {id: lock.id}}")
                    a(href='#')
                      .edit-list
                        span.icon 

              .list-info
                strong {{ lock.type.label }}
                br
                | {{ lock.date_start }} - {{ lock.date_end }}
                br
                strong(v-if="lock.professional") {{ lock.professional.name }}

          .pagination
            pagination(:pagination="pagination", @pagination-changed-page="setPage")
</template>



// WEBPACK FOOTER //
// src/app/professional/agenda/locks/index/index.vue